package top.wcpe.allincore.ui.runtime.ir.call

import top.wcpe.allincore.ui.runtime.host.TimerHandle

/**
 * DSL 中 `timer.timeout(...) { }` / `timer.interval(...) { }` 拿到的运行时值。
 *
 * 仅暴露 `cancel()` / `isCancelled()` 两个方法；session dispose 时由 framework
 * 调用 TimerHost.dispose 取消所有 handle，DSL 无需手动管理。
 *
 * 调用形态：
 * ```
 * var t = timer.interval(200) { state.frame = state.frame + 1 }
 * t.cancel()
 * if (t.isCancelled()) { ... }
 * ```
 */
class TimerHandleValue(val handle: TimerHandle) {

    /** 取消 timer（幂等）。 */
    fun cancel() {
        handle.cancel()
    }

    /** 是否已取消（含周期 timer 被 cancel 或一次性 timer 已触发完毕的情形）。 */
    fun isCancelled(): Boolean = handle.isCancelled()

    override fun toString(): String = "TimerHandleValue(cancelled=${handle.isCancelled()})"
}
